import React, { useEffect, useState } from "react";
import { settingService } from "../../../services/extensions";
import { PickList } from "primereact/picklist";
import { Dropdown } from "primereact/dropdown";
import { toast } from "react-toastify";
import { Toolbar } from "primereact/toolbar";
import { Util } from "../../../services";
import { InputSwitch } from 'primereact/inputswitch';
import { useSelector } from 'react-redux';
import { selectUser } from '../../../services/store/userSlice';
function UsersActivityMapping() {
  const user = useSelector(selectUser);
  const empIndex = user.roles.indexOf('Masters Admin', 'Users Admin', 'ADMIN');
  const [users, setUsers] = useState([]);
  const [projects, setProjects] = useState([]);
  const [filterMasterActivity, setFilterMasterActivity] = useState([]);
  const [selProject, setSelProject] = useState([]);
  const [activity, setActivity] = useState([]);
  const [selUser, setSelUser] = useState(null);
  const [masterActivity, setMasterActivity] = useState([]);
  const [selectedType, setSelectedType] = useState("");
  const [selectedRowData, setSelectedRowData] = useState([]);
  const [selectedProject, setSelectedProject] = useState("");
  const [billableNonBillable, setBillableNonBillable] = useState(true);

  useEffect(() => {
    getProjectsByUser();
    // getUsersList();
    getMasterActivity();
  }, []);
  useEffect(() => {
    if(selProject && selProject.id){
    getUsersList(selProject.id);
  }
  }, [selProject.id]);

  const getProjectsByUser = () => {
    if (empIndex === 1) {
      settingService.getProjects().then(resp => {
        setProjects(resp.data.data);
      });
    } else {
      settingService.getProjectsByUser().then((resp) => {
        setProjects(resp.data.data);
      });
    }
  };
  
  const getMasterActivity = () => {
    settingService.getAllMasterActivity().then((resp) => {
      var masterActivityList = [];
      masterActivityList = resp.data.data.filter((i) => {
        return i.isBillable;
      });
      setMasterActivity(masterActivityList);
      setFilterMasterActivity(resp.data.data);
    });
  };
  
  const getUsersList = (selProject = {}) => {
    let param ;
    param = {
      projectIds: [selProject]
    }
      settingService.getUsersByProjectId(param).then((resp) => {
      var userListing = [];
      var proUser = [];
      resp.data.data.map((item)=>{
        item.Allocations.map((items)=>{
          if(items.projectId ===selProject){
            proUser.push(item)
          }
          return items.projectId ===selProject;
        })
        return item.firstName;
      });
      
      let proNameUnique = Array.from(new Set(proUser));
      proNameUnique.map((item) => {
        let objProject = {
          id: item.id,
          name: item.firstName.charAt(0).toUpperCase() + item.firstName.slice(1) + " " + item.lastName.charAt(0).toUpperCase() + item.lastName.slice(1),
        };
        userListing.push(objProject);
      });
      setUsers(userListing);
    });
  };

  const filterProject = (data) => {
    setSelectedProject(data.id);
    setSelUser(null);
    setSelProject(data);
  };

  const filterUser = (data,selProjec) => {
    let userFilter;
    let projectFilter;
    setSelUser(data);
    const param = { projectId: selectedProject, status: 1 };
    settingService.getFilteredActivities(param).then((resp) => {
      let restMasterArray;
      projectFilter = resp.data.data.filter((item) => {
        return item.userId === null;
      });
      userFilter = resp.data.data.filter((item) => {
        return item.userId === data.id;
      });
      let matchedCategory = [...projectFilter, ...userFilter];

      if (billableNonBillable) {
        let masterActivityList = filterMasterActivity.filter((i) => {
          return i.isBillable;
        });
        restMasterArray = masterActivityList.filter(
          ({ title: id1, isBillable: id3 }) =>
            !matchedCategory.some(({ title: id2, isBillable: id4 }) => id2 === id1 && id4 === id3)
        );
      } else {
        let masterActivityList = filterMasterActivity.filter((i) => {
          return !i.isBillable;
        });
        restMasterArray = masterActivityList.filter(
          ({ title: id1, isBillable: id3 }) =>
            !matchedCategory.some(({ title: id2, isBillable: id4 }) => id2 === id1 && id4 === id3)
        );
      }
      setMasterActivity(restMasterArray);
      setActivity(userFilter);
    });
  };

  const onChange = (event) => {
    if (selProject.length === 0 && selUser.length === 0) {
      toast.error("Please select Project and User!");
      return 1;
    } else if (selProject.length === 0) {
      toast.error("Please select Project!");
      return 1;
    } else if (selUser.length === 0) {
      toast.error("Please select User!");
      return 1;
    }
    // moving all element source to target
    if (event.source.length === 0 && event.target.length !== 0) {
      var selectedSource = [];
      event.target.map((item) => {
        if (!item.projectId && !item.userId) {
          selectedSource.push(item);
        }
      });
      var proListing = [];
      selectedSource.map((item) => {
        let objProject = {
          projectId: selProject.id,
          userId: selUser.id,
          code: item.code,
          title: item.title,
          isBillable: item.isBillable,
          type: item.type,
        };
        proListing.push(objProject);
      });
      let param = proListing;
      settingService.addActivityInBulk(param).then((resp) => {
        setMasterActivity(event.source);
        setActivity(event.target);
        filterProject(selProject);
        filterUser(selUser);
      });
      return true;
    }

    if (event.target.length === 0 && event.source.length !== 0) {
      const activityIds = activity.map((x) => {
        return x.id;
      });
      const reqbulkBody = { Ids: activityIds };
      settingService.bulkDeleteActivityById(reqbulkBody).then((resp) => {
        setMasterActivity(event.source);
        setActivity(event.target);
        filterProject(selProject);
        filterUser(selUser);
      });
      return true;
    }

    if (selProject.length !== 0 && selUser.length !== 0) {
      if (selectedType === "source") {
        // Add Category
        var proListing = [];
        selectedRowData.map((item) => {
          let objProject = {
            projectId: selProject.id,
            userId: selUser.id,
            code: item.code,
            title: item.title,
            isBillable: item.isBillable,
            type: item.type,
          };
          proListing.push(objProject);
        });
        let param = proListing;
        settingService.addActivityInBulk(param).then((resp) => {
          setMasterActivity(event.source);
          setActivity(event.target);
          filterProject(selProject);
          filterUser(selUser);
        });
      }

      if (selectedType === "target") {
        const activityIds = selectedRowData.map((x) => {
          return x.id;
        });
        const reqbulkBody = { Ids: activityIds };
        settingService.bulkDeleteActivityById(reqbulkBody).then((resp) => {
          setMasterActivity(event.source);
          setActivity(event.target);
          filterProject(selProject);
          filterUser(selUser);
        });
      }
    }
  };
  const onSourceSelectionChange = (e) => {
    setSelectedRowData(e.value);
    setSelectedType("source");
  };
  const onTargetSelectionChange = (e) => {
    setSelectedRowData(e.value);
    setSelectedType("target");
  };

  const rightToolbarTemplate = () => {
    return (
      <React.Fragment>
        <div style={{display: 'flex', justifyContent: 'flex-start', alignItems: 'center', flexWrap: 'wrap', gap: '15px'}}>
          <div>
            <h3>Select Project</h3>
            <Dropdown filter id="projects_list" className="mb-3 mr-3" name="projects_list" options={projects} value={selProject} onChange={(e) => filterProject(e.value)} optionLabel="title" placeholder="Select Project" style={{minWidth: '180px'}} />
            <Dropdown filter id="projects_list" className="project_list mr-3" name="projects_list" options={projects} value={selProject} onChange={(e) => filterProject(e.value)} optionLabel="title" placeholder="Select Project" 
            style={{minWidth: '180px'}}
            />
          </div>

          <div>
            <h3>Select User</h3>
            <Dropdown id="users_list" name="users_list" className="users_list mb-3" options={users} value={selUser} onChange={(e) => filterUser(e.value)} optionLabel="name" filter showClear filterBy="name" placeholder="Select User" 
            style={{minWidth: '180px'}}
            />
          </div>
        </div> 
      </React.Fragment>
    );
  };

  const changeBillableNonBillable = (e) => {
    var masterActivityList = [];
    if (selUser?.id) {
      if (e.value) {
        let billableActivityList = filterMasterActivity.filter((i) => {
          return i.isBillable;
        });
        masterActivityList = billableActivityList.filter(
          ({ title: id1, isBillable: id3 }) =>
            !activity.some(({ title: id2, isBillable: id4 }) => id2 === id1 && id4 === id3)
        );
      } else {
        let billableActivityList = filterMasterActivity.filter((i) => {
          return !i.isBillable;
        });
        masterActivityList = billableActivityList.filter(
          ({ title: id1, isBillable: id3 }) =>
            !activity.some(({ title: id2, isBillable: id4 }) => id2 === id1 && id4 === id3)
        );
      }
    } else {
      if (e.value) {
        masterActivityList = filterMasterActivity.filter((i) => {
          return i.isBillable;
        });
      } else {
        masterActivityList = filterMasterActivity.filter((i) => {
          return !i.isBillable;
        });
      }
    }
    setMasterActivity(masterActivityList);
    setFilterMasterActivity(filterMasterActivity);
    setBillableNonBillable(e.value);
  }

  const leftToolBarTemplate = () => {
    return (
      <React.Fragment>
        <div className="mr-4"><strong>Filter By Activity (Non-Billable) </strong></div> <InputSwitch checked={billableNonBillable} onChange={(e) => changeBillableNonBillable(e)} /> <div className="ml-4"><strong>(Billable) </strong></div>
      </React.Fragment>
    );
  }

  return (
    <React.Fragment>
      <div>
        <Toolbar className="mb-2" left={leftToolBarTemplate} right={rightToolbarTemplate}></Toolbar>
      </div>
      <PickList
        filterBy="title"
        source={masterActivity}
        target={activity}
        // itemTemplate={itemBody}
        itemTemplate={Util.activityItemBody}
        sourceHeader="Master Activity"
        targetHeader="User Activity"
        sourceStyle={{ height: "23.6vw" }}
        targetStyle={{ height: "23.6vw" }}
        onChange={onChange}
        onSourceSelectionChange={(e) => onSourceSelectionChange(e)}
        onTargetSelectionChange={(e) => onTargetSelectionChange(e)}
        className="col-8 col-offset-2"
        // style={{ marginLeft: "13vw" }}
        showSourceControls={false}
        showTargetControls={false}
      />
    </React.Fragment>
  );
}

export default UsersActivityMapping;
